<template>
  <div class="Index" v-if="!is_mobile">
    <div class="libe_home_nav animate__animated animate__fadeInDown" v-if="scroll >= 88">
      <headNav :activeNav="'Inicio'"></headNav>
    </div>
    <div class="libe_home_wrap">
      <div class="libe_homenav" v-if="scroll < 88">
        <homeNav :activeNav="'Inicio'"></homeNav>
      </div>
      <div class="libe_home_banner">
        <div class="lalanita_banner_vmg">
          <img src="../assets/imgs/lalanita_banner_1n.webp" alt="">
        </div>
      </div>

      <div class="eshoy_home_google_link">
        <a href="https://play.google.com/store/apps/details?id=com.mx.lalanitaplus" target="_blank" class="playBtn">
          <div class="google_link_wrap"></div>
        </a>
        <a href="https://apps.apple.com/mx/app/lalanita/id6736835339" target="_blank" class="playBtn">
          <div class="ios_link_wrap"></div>
        </a>
      </div>
      <div class="lalanitahome1v">
        <div class="lalanitahome1v_view animate__animated" :class="{ 'animate__fadeInUp': fadeinActive1, 'lalanitahome1v_view_active': fadeinActive1}">
          <div class="lalanitahome1v_vtop">
            <div class="lalanitahome1v_vtleft">
              <div class="lalanitahome1v_vtlmg">
                <img src="../assets/imgs/lalanitahome1v_vtl_1.webp" alt="">
              </div>
              <div class="lalanitahome1v_vtltx">
                Seguridad de datos<br>garantizada
              </div>
            </div>
            <div class="lalanitahome1v_vtright">
              <span>Todas sus datos sera almacenados bajo supervisión de instituciones autorizadas. Mantenemos sus informaciones privadas bien protegidas.</span>
            </div>
          </div>
          <div class="lalanitahome1v_vdon">
            <img src="../assets/imgs/lalanitahome1v_vtl_s.webp" alt="">
          </div>
        </div>

        <div class="lalanitahome1v_view animate__animated" :class="{ 'animate__fadeInUp': fadeinActive2, 'lalanitahome1v_view_active': fadeinActive2}">
          <div class="lalanitahome1v_vtop">
            <div class="lalanitahome1v_vtleft">
              <div class="lalanitahome1v_vtlmg">
                <img src="../assets/imgs/lalanitahome1v_vtl_2.webp" alt="">
              </div>
              <div class="lalanitahome1v_vtltx">
                Servicio de pago a plazos<br>garantizada
              </div>
            </div>
            <div class="lalanitahome1v_vtright">
              <span>Ofrecemos pago a plazos y pago de 1 plazo largo para aliviar la presión de los pagos y los costos generados durante el proceso del prestamo.</span>
            </div>
          </div>
          <div class="lalanitahome1v_vdon">
            <img src="../assets/imgs/lalanitahome1v_vtl_s.webp" alt="">
          </div>
        </div>

        <div class="lalanitahome1v_view animate__animated" :class="{ 'animate__fadeInUp': fadeinActive3, 'lalanitahome1v_view_active': fadeinActive3}">
          <div class="lalanitahome1v_vtop">
            <div class="lalanitahome1v_vtleft">
              <div class="lalanitahome1v_vtlmg">
                <img src="../assets/imgs/lalanitahome1v_vtl_3.webp" alt="">
              </div>
              <div class="lalanitahome1v_vtltx">
                Beneficios y<br>promociones sin<br>límites
              </div>
            </div>
            <div class="lalanitahome1v_vtright">
              <span>Brindamos beneficios y organizar promociones para usuarios fieles constantemente. Los cupones recibidos pueden reducir su monto a pagar final.</span>
            </div>
          </div>
          <div class="lalanitahome1v_vdon"></div>
        </div>
      </div>

      <div class="lalanitahome2v">
        <div class="lalanitahome2v_head">
          <div class="lalanitahome2v_ht">¡Recibir préstamo rápido y sin</div>
          <div class="lalanitahome2v_ht">complicaciones con LaLANITA!</div>
        </div>

        <div class="laite_descview">
          <div class="laite_descview_list">
            <div class="laite_descvitems">
              <div class="laite_descvitem">
                <div class="lalanitahome2v_hmg">
                  <img src="../assets/imgs/lalanitahome2v_h1.webp" alt="">
                </div>
                <div class="lalanitahome2v_d12">
                  <div class="lalanitahome2v_d1">Paso 1:</div>
                  <div class="lalanitahome2v_d2">Descargar nuestra app oficial</div>
                </div>
                <div class="lalanitahome2v_d3">Nuestra plataforma está disponible en Google Play llamada "LaLANITAplus" y en App Store puede buscar "LaLANITA".</div>
              </div>
            </div>
            <div class="laite_descvitems">
              <div class="laite_descvitem">
                <div class="lalanitahome2v_hmg">
                  <img src="../assets/imgs/lalanitahome2v_h2.webp" alt="">
                </div>
                <div class="lalanitahome2v_d12">
                  <div class="lalanitahome2v_d1">Paso 2:</div>
                  <div class="lalanitahome2v_d2">Registrar y completar solicitud</div>
                </div>
                <div class="lalanitahome2v_d3">Para solicitar hay que ser mayor de 18 años y residente en México. Cuenta con INE vigente y tarjeta bancaria propia.</div>
              </div>
            </div>
            <div class="laite_descvitems">
              <div class="laite_descvitem">
                <div class="lalanitahome2v_hmg">
                  <img src="../assets/imgs/lalanitahome2v_h3.webp" alt="">
                </div>
                <div class="lalanitahome2v_d12">
                  <div class="lalanitahome2v_d1">Paso 3:</div>
                  <div class="lalanitahome2v_d2">Esperar la aprobación y dinero</div>
                </div>
                <div class="lalanitahome2v_d3">Una vez su solicitud de préstamo está aprobada, el dinero se depositará directamente en tu cuenta bancaria.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="lalanitahome3v">
        <div class="lalanitahome3v_t">LaLANITA es la opción preferida por</div>
        <div class="lalanitahome3v_t">miles de mexicanos para sus</div>
        <div class="lalanitahome3v_t">necesidades de liquidez.</div>
      </div>

    </div>

    <div class="baroli_hscrollcdown">
      <div class="beat_prize_wrap">
        <div class="beat_prize_cont">
          <div id="ndan_prizelist_cdv" class="ndan_prizelist_cdv">
            <ul>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll01.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll02.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll03.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll04.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll05.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll06.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll07.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll08.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll09.webp" alt="">
                </div>
              </li>
              <li>
                <div class="baroli_hscrollcdview">
                  <img src="@/assets/imgs/lala_scroll10.webp" alt="">
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div class="baroli_hscrmask_left"></div>
        <div class="baroli_hscrmask_right"></div>
      </div>
    </div>

    <div class="lalanitahome4v">
      <div class="lalanitahome4v_vmg">
        <img src="../assets/imgs/lalanitahome4v_1n.webp" alt="">
      </div>
    </div>

    <footPage></footPage>

    <div id="lalanita_fradue">
      <el-dialog
        title=" "
        :visible.sync="dialogVisible"
        :show-close="isFalse"
        width="1200px">
        <template slot="title">
          <div class="laita_fraude_title">
              <div class="laita_fraude_close" @click.stop="onCloseFraude">
                <img src="@/assets/imgs/laita_fraude_icon.png" alt="">
              </div>
          </div>
        </template>
        <div class="laita_about_view">
          <div class="laita_fraude_icon">
            <img src="@/assets/imgs/laita_fraude_close.png" alt="">
          </div>
          <div class="laita_about_title">Aviso Antifraude</div>
          <div class="laita_about_desc">
            ⚠️Recuerda que en LaLANITAplus nunca pedimos información confidencial más allá de la necesaria para solicitar un préstamo, y esa información siempre estar protegida. Jamás contactamos por canales que no sean oficiales ❗
          </div>
          <div class="laita_about_desc">
            ⚠️No solicitamos pagos por adelantado antes de pedir un préstamo o liquidar uno. Puedes liquidar el préstamo antes de la fecha de vencimiento, pero nunca cobramos comisiones o cargos de gestión, ni proporcionamos códigos QR de pago distintos a los que aparecen en la app o con algún tipo de descuento ❗
          </div>
          <div class="laita_about_desc">
            ⚠️No requeremos que realice transferencias/pagos a cuentas fuera de las páginas oficiales de pago.
          </div>
          <div class="laita_fraude_message">
            Si recibe algun mensaje o información sospechosa de fraude, por favor, contáctenos de inmediato:
          </div>
          <div class="laita_fraude_connect">
            <div class="laita_fraude_cnttext">📧Correo：servicioplus@lalanitaplus.com</div>
            <div class="laita_fraude_cnttext">☎️Teléfono：5585261054</div>
            <div class="laita_fraude_cnttext">📱Whatsapp：7204712755</div>
          </div>
          <div class="laita_fraude_warnview">
            Además, te invitamos a reportar cualquier intento de fraude. Si confirmamos que la información es efectiva, recompensamos con un cupón/descuento, como agradecimiento.
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
  <div v-else class="mobile_viewrap">
    <div class="mobile_wrap">
      <mobNav :activeNav="activeNav"></mobNav>
    </div>
    <div class="mobhome_banner">
      <div class="mobhome_banner_cont">
        <img src="@/assets/mobimg/home_banner01.webp" />
      </div>
    </div>
    <div class="mobhome_download">
      <div class="mobhome_dcont">
        <div class="mobhome_dcont_items">
          <a
                  href="https://play.google.com/store/apps/details?id=com.mx.lalanitaplus"
                  target="_blank"
                  class="playBtn"
          >
            <img src="@/assets/mobimg/google_icon_next.webp" />
          </a>
        </div>
        <div class="mobhome_dcont_items">
          <a
                  href="https://apps.apple.com/mx/app/lalanita/id6736835339"
                  target="_blank"
                  class="playBtn"
          >
            <img src="@/assets/mobimg/ios_icon_next.webp" />
          </a>
        </div>
      </div>
    </div>
    <div class="mobhome_onewrap" style="padding-bottom: 1.2rem;">
      <div class="mobhome_oneview">
        <img src="@/assets/mobimg/lalanita_home_top_one.png" />
      </div>
    </div>

    <div class="mobhome_onewrap" style="background: #F6F6F7;padding-top: 0;">
      <div class="mobhome_twoview">
        <div class="mobhome_tview">
          <div class="eshoy_slider_cont mobhome_tview_slider">
            <div class="loan-content-box">
              <div class="moneybox">
                $ <span id="money">{{ dealNumber(sliderValue) }}</span>
              </div>
              <div class="loan-select-box">
                <div class="loan-select-item"
                     :class="isActive == 90 ? 'selected' : ''"
                     @click="getDays(90)"
                >
                  90 Días
                </div>
                <div class="loan-select-item"
                     :class="isActive == 120 ? 'selected' : ''"
                     @click="getDays(120)"
                >
                  120 Días
                </div>
                <div class="loan-select-item"
                     :class="isActive == 180 ? 'selected' : ''"
                     @click="getDays(180)"
                >
                  180 Días
                </div>
              </div>

              <div class="sliderbox_wrap">
                <div class="sliderbox_left">
                  <div class="sliderbox_cimg">
                    <img src="@/assets/img/eshoy_gold_small.png" alt="">
                  </div>
                  <div class="sliderbox_ctext">$<span>200</span></div>
                </div>
                <div class="sliderbox_middle">
                  <div class="sliderBox">
                    <el-slider
                            v-model="sliderValue"
                            :min="200"
                            :max="24000"
                            :show-tooltip="false"
                    ></el-slider>
                  </div>
                </div>
                <div class="sliderbox_right">
                  <div class="sliderbox_cimg">
                    <img src="@/assets/img/eshoy_gold_more.png" alt="">
                  </div>
                  <div class="sliderbox_ctext">$<span>24,000</span></div>
                </div>
              </div>
            </div>
            <div class="eshoy_slider_btns">
              <div class="eshoy_slider_btn_view animate__animated animate__infinite animate__pulse">
                <img src="@/assets/imgs/plapla_slider_btn_one.png" alt="" />
              </div>
            </div>
            <div class="laita_solider_down_view">
              <img src="@/assets/imgs/laita_solider_down.png" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--<div class="mobhome_dview">
      <div class="laite_descview">
        <div class="laite_descview_list" style="display: block;">
          <div class="laite_descvitems">
            <div class="laite_descvitem" style="width: 5.0rem; height: 7.194444rem;">
              <img src="@/assets/imgs/laite_descvitem_one.png" alt="" style="display: block; width: 5.0rem; height: 7.194444rem;">
            </div>
          </div>
          <div class="laite_descvitems">
            <div class="laite_descvitem" style="width: 5.0rem; height: 7.083333rem;">
              <img src="@/assets/imgs/laite_descvitem_two.png" alt="" style="display: block; width: 5.0rem; height: 7.083333rem;">
            </div>
          </div>
          <div class="laite_descvitems">
            <div class="laite_descvitem" style="width: 5.0rem; height: 7.277778rem;">
              <img src="@/assets/imgs/laite_descvitem_thr.png" alt="" style="display: block; width: 5.0rem; height: 7.277778rem;">
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <mobFooter></mobFooter>

  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";
import homeNav from "@/components/homeNav.vue";
import footPage from "@/components/foot.vue";
import mobNav from "@/components/mobNav.vue";
import mobFooter from "@/components/mobfooter.vue";
import mobileOrpc from "@/mixins/index";

var spa = -1;
function move(oul){
  if(oul){
    if(oul.offsetLeft<-oul.offsetWidth/2){
      oul.style.left='0';
    }
    if(oul.offsetLeft>0){
      oul.style.left=-oul.offsetWidth/2+'px'
    }
    oul.style.left=oul.offsetLeft+spa+'px';
  }

}

function squareMove(oul) {
  function updateAnimation() {
    if(oul) {
      if (oul.offsetLeft < -oul.offsetWidth / 2) {
        oul.style.left = '0';
      }
      if (oul.offsetLeft > 0) {
        oul.style.left = -oul.offsetWidth / 2 + 'px'
      }
      //console.log(oul.offsetLeft+spa)
      oul.style.left = oul.offsetLeft + spa + 'px';
      window.requestAnimationFrame(updateAnimation)
    }
  }
  if(oul){
    oul.style.left='0';
    window.requestAnimationFrame(updateAnimation)
  }
}

export default {
    name: 'Index',
    components: { headNav, homeNav, footPage,mobNav, mobFooter },
    mixins: [mobileOrpc],
    data () {
      return {
        isFalse: false,
        activeNav: "Inicio",
        scroll: 0,
        changeNum: 0,
        sliderValue: 20000,
        isActive: 90,
        dialogVisible: false,
        fadeinActive1: false,
        fadeinActive2: false,
        fadeinActive3: false,
      }
    },
    created() {
      let nav = localStorage.getItem('activeNav');
      if (nav) {
        this.activeNav = nav;
      } else {
        localStorage.setItem('activeNav', this.activeNav);
      }
    },
    mounted(){
      window.addEventListener('scroll',this.handleScroll)
      document.body.scrollTop = document.documentElement.scrollTop=0;

      console.log('是否为移动端')
      console.log(this.is_mobile)

      window.addEventListener('scroll',this.handleScroll);

      var odiv = document.getElementById('ndan_prizelist_cdv');
      var oul = odiv.getElementsByTagName('ul')[0];
      var ali = oul.getElementsByTagName('li');
      oul.innerHTML=oul.innerHTML+oul.innerHTML;
      oul.style.width=ali[0].offsetWidth*ali.length+'px';

      // requestAnimationFrame版
      if(window.requestAnimationFrame){
        let timer = null;
        squareMove(oul);
        timer = squareMove();
        odiv.onmouseenter=function(){cancelAnimationFrame(timer);}
        odiv.onmouserleava=function(){timer = squareMove()};
      } else {
        // 定时器版
        move(oul)
        var timer = setInterval(move,30)
        odiv.onmouseenter=function(){clearInterval(timer);}
        odiv.onmouserleava=function(){timer = setInterval(move,30)};
      }
    },
    methods: {
      onCloseFraude() {
        this.dialogVisible = false;
      },
      gotoHelp() {
        this.$router.push({
          path: '/help',
        })
      },
      handleScroll(){
        //或者使用document.querySelector('.class或者#id').scrollTop
        this.scroll = document.documentElement.scrollTop||document.body.scrollTop
        console.log(this.scroll)

        if(this.scroll > 90){
          this.fadeinActive1 = true;
        } else {
          this.fadeinActive1 = false;
        }

        if(this.scroll > 430){
          this.fadeinActive2 = true;
        } else {
          this.fadeinActive2 = false;
        }

        if(this.scroll > 670){
          this.fadeinActive3 = true;
        } else {
          this.fadeinActive3 = false;
        }

      },
      getDays(day) {
        this.isActive = day;
      },
      dealNumber(num) {
        if (num != 0 && num) {
          num = num + "";
          let splitList = num.split(".");
          //将整数部分拆解为单个数字的数组倒序，然后拼装为新的数组，每3位数字进行一次匹配
          let intStrList = splitList[0]
                  .split("")
                  .reverse()
                  .join("")
                  .match(/(\d{1,3})/g);
          //将匹配后的数组用，拼接，再拆解为单个数字的数组，反转为原先数组形式，拼接为完整数字
          let intStr = intStrList.join(",").split("").reverse().join("");
          return intStr;
        }
        return num;
      },
    },
    //销毁,否则跳到别的路由还是会出现
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }
</script>

<style>
  .libe_home_wrap{
    width: 100%;
    height: auto;
    position: relative;
    background: #FFFFFF;
  }
  .libe_home_nav{
    width: 100%;
    height: auto;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1010;
  }
  .libe_homenav{
    width: 100%;
    height: auto;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 8;
  }
  .libe_home_banner{
    width: 100%;
    height: 706px;
    position:relative;
    overflow:hidden;
    z-index: 2;
    box-sizing: border-box;
    padding: 144px 0 0 0;
  }
  .lalanita_banner_vmg{
    width: 1400px;
    height: 562px;
    margin: 0 auto;
  }
  /*.libe_home_banner_img{
    width: 1920px;
    height: 780px;
    position:absolute;
    left:50%;
    margin-left:-960px;
  }*/
  .eshoy_home_google_link{
    width: 1400px;
    height: auto;
    margin: 0 auto;
    position: relative;
  }
  .libe_home_top{
    width: 1400px;
    height: auto;
    margin: 0 auto;
    position: relative;
    background: #FFFFFF;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding-top: 120px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255,255,255, 0.2);
  }
  .libe_home_top_img{
    width: 1218px;
    height: 274.5px;
    margin: 0 auto;
  }
  .libe_home_top_img img{
    display: block;
    width: 100%;
  }
  .libe_home_down{
    width: 1300px;
    height: auto;
    margin: 0 auto;
    padding-top: 140px;
  }
  .libe_home_down img{
    display: block;
    width: 100%;
  }
  .Index {
    width: 100%;
    height: 100%;
    background-color: #fff;
    margin: 0;
    padding: 0;
  }
  .fotop_cont_dit_img img{
    display: block;
    width: 100%;
  }
  .google_link_wrap{
    width: 180px;
    height: 60px;
    position: absolute;
    left: 80px;
    top: -166px;
    z-index: 6;
    cursor: pointer;
    background: url("../assets/imgs/lalanita_googleplay_1.webp") no-repeat center center;
    background-size: 100% 100%;
  }
  .google_link_wrap:hover{
    background: url("../assets/imgs/lalanita_googleplay_2.webp") no-repeat center center;
    background-size: 100% 100%;
  }
  .ios_link_wrap{
    width: 180px;
    height: 60px;
    position: absolute;
    left: 308px;
    top: -166px;
    z-index: 6;
    cursor: pointer;
    background: url("../assets/imgs/lalanita_appstore_1.webp") no-repeat center center;
    background-size: 100% 100%;
  }
  .ios_link_wrap:hover{
    background: url("../assets/imgs/lalanita_appstore_2.webp") no-repeat center center;
    background-size: 100% 100%;
  }
  .eshoy_slider_wrap{
    width: 100%;
    height: 740px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: #F6F6F7;
  }
  .eshoy_slider_cont{
    width: 1200px;
    height: 624px;
    margin: 0 auto;
    background-size: 100% 100%;
  }
  .loan-content-box {
    width: 100%;
    height: auto;
    padding-top: 85px;
  }

  .loan-select-box {
    width: 70%;
    display: flex;
    justify-content: space-around;
    margin: 0 auto;
  }

  .loan-select-item {
    width: 200px;
    height: 50px;
    background: #ffffff;
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.06);
    border-radius: 25px;
    color: #8E9190;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    line-height: 50px;
    cursor: pointer;
  }

  .Index .loan-select-item.selected {
    background: #FFFFFF rgba(165,247,170,0.06);
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.06);
    border-radius: 25px;
    box-sizing: border-box;
    border: 1px solid #3CCA8C;
    color: #3CCA8C;
    font-size: 18px;
    font-family: MiSans-Semibold, MiSans;
    font-weight: 600;
  }

  .moneybox {
    font-size: 58px;
    font-weight: 600;
    color: #444444;
    text-align: center;
    font-family: Helvetica;
    text-align: center;
    padding-bottom: 74px;
  }

  .moneybox span {
    font-size: 58px;
  }

  .sliderBox {
    width: 546px;
    height: auto;
    background: #E4EFEB;
    border-radius: 5px;
    margin: 24px auto 0 auto;
    position: relative;
  }

  .range {
    display: none;
    justify-content: space-between;
    margin-top: 35px;
  }

  .range p {
    font-size: 16px;
    color: #666;
    font-weight: 500;
  }

  .range p span {
    font-size: 18px;
  }
  .el-slider__runway {
    height: 10px !important;
    margin: 0 !important;
    background-color: #E4EFEB !important;
    border-radius: 5px !important;
  }

  .el-slider__bar {
    height: 10px !important;
    border-radius: 5px !important;
    background-color: #2FA96B !important;
  }

  .el-slider__button-wrapper {
    width: 69px !important;
    height: 70px !important;
    background: url(../assets/img/sliderBtn.png) top center no-repeat;
    background-size: cover;
    cursor: pointer;
    border: none !important;
    background-color: transparent !important;
    top: -27px !important;
  }

  .el-slider__button {
    border: none !important;
    background-color: transparent !important;
  }
  .sliderbox_wrap{
    width: 762px;
    height: 86px;
    padding-top: 37px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .sliderbox_left{
    width: 88px;
    height: 86px;
  }

  .sliderbox_right{
    width: 88px;
    height: 86px;
  }
  .sliderbox_cimg{
    width: 88px;
    height: 50px;
  }
  .sliderbox_ctext{
    width: 100%;
    height: 36px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 500;
    color: #8C8480;
    line-height: 36px;
    text-align: center;
  }
  .sliderbox_ctext span{
    padding-left: 6px;
  }
  .eshoy_slider_btns{
    width: 640px;
    height: 72px;
    margin: 80px auto 0 auto;
    cursor: pointer;
  }
  .eshoy_slider_btn_view{
    width: 640px;
    height: 72px;
  }
  .eshoy_slider_btns img{
    display: block;
    width: 100%;
  }
  .libe_home_down_cont{
    width: 100%;
    height: 583px;
    padding-top: 80px;
  }
  .libe_home_dview{
    width: 648px;
    margin: 0 auto;
    position: relative;
  }
  .libe_home_dvitem_one{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-left: 107px;
    padding-right: 60px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 5;
  }
  .libe_home_dvitem_one img{
    display: block;
    width: 100%;
  }
  .libe_home_dvitem_two{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-right: 109px;
    position: absolute;
    left: 0;
    top: 101px;
    z-index: 4;
  }
  .libe_home_dvitem_two img{
    display: block;
    width: 100%;
  }
  .libe_home_dvitem_thr{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-left: 109px;
    position: absolute;
    left: 0;
    top: 203px;
    z-index: 3;
  }
  .libe_home_dvitem_thr img{
    display: block;
    width: 100%;
  }
  .libe_home_dvitem_fur{
    width: 648px;
    height: 139px;
    box-sizing: border-box;
    padding-right: 109px;
    position: absolute;
    left: 0;
    top: 304px;
    z-index: 2;
  }
  .plapla_centro_view{
    width: 100%;
    height: auto;
    margin: 0 auto;
    background: #ffffff;
  }
  .plapla_centro_wrap{
    width: 1200px;
    height: auto;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 120px 0 120px 0;
    border-top: 1px solid rgba(255,255,255,0.2);
  }
  .plapla_centro_cont{
    width: 100%;
    height: auto;
  }
  .plapla_centro_cont img{
    display: block;
    width: 100%;
  }
  .plapla_centro_desc{
    width: 100%;
    height: auto;
    padding-top: 50px;
    font-size: 18px;
    font-family: MiSans-Regular, MiSans;
    font-weight: 400;
    color: #FFFFFF;
    cursor: pointer;
  }
  .plapla_centro_desc span{
    color: #39CA80;
    text-decoration: underline;
  }

  .mobile_viewrap{
    width: 100%;
    background: #ffffff;
  }
  .mobile_wrap{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 9999;
  }
  .mobile_wrap .van-cell{
    padding: 0;
    background-color: #FFFFFF !important;
  }
  .mobile_wrap .van-collapse-item{
    background-color: #FFFFFF !important;
  }
  .mobile_wrap .van-cell--clickable:active {
    background-color: #FFFFFF !important;
  }
  .mobile_wrap .van-collapse-item__content{
    padding: 0;
    background-color: #FFFFFF !important;
  }
  .mobile_wrap .common_problem_wrap_mobile{
    width: 100%;
    height: auto;
    padding-top: 0;
    padding-bottom: 0;
  }
  .mobile_wrap .common_problem_view_mobile{
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.555556rem 0 0.555556rem;
    background: #ffffff;
  }
  .mobile_wrap .common_title_wrap{
    width: 100%;
    height: 1.777778rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 0 0 0.694444rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mobile_wrap .common_title_left{
    width: auto;
    height: 0.666667rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mobile_wrap .common_tleft_icon{
    width: 3.7rem;
    height: 0.805556rem;
  }
  .mobile_wrap .common_tleft_icon img{
    display: block;
    width: 100%;
  }
  .mobile_wrap .common_tleft_text{
    width: auto;
    padding-left: 0.277778rem;
    font-size: 0.388889rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8C8E94;
  }
  .mobile_wrap .common_title_left .isopen{
    color: #FFFFFF;
  }
  .mobile_wrap .common_title_right{
    width: auto;
    height: 1.777778rem;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-right: 0.833333rem;
  }
  .mobile_wrap .common_trview{
    width: 0.666667rem;
    height: 0.666667rem;
  }
  .mobile_wrap .common_trview img{
    display: block;
    width: 100%;
  }
  .mobile_wrap .common_children_wrap{
    width: 100%;
    height: calc(100vh - 1.777778rem);
    box-sizing: border-box;
    padding-top: 0.555556rem;
    padding-left: 0.555556rem;
    padding-bottom: 0.555556rem;
    padding-right: 0;
  }
  .mobile_wrap .children_title_wrap{
    width: 100%;
    height: auto;
    padding-top: 0.555556rem;
  }
  .mobile_wrap .children_title_left{
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
  }
  .mobile_wrap .children_tleft_icon{
    width: 0.5rem;
    height: 0.472222rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mobile_wrap .children_tleft_icon img{
    display: block;
    width: 0.277778rem;
    height: 0.277778rem;
  }
  .mobile_wrap .children_tleft_text{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding-right: 1.055556rem;
    font-size: 0.333333rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255,255,255,0.8);
    line-height: 0.472222rem;
  }
  .mobile_wrap .children_cont{
    width: 100%;
    height: auto;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.222222rem 1.055556rem 0 0.472222rem;
    overflow-y: scroll;
  }
  .mobile_wrap .children_cont_items{
    width: 100%;
    height: 1.555556rem;
    font-size: 0.444444rem;
    color: #5A5A63;
    line-height: 1.555556rem;
  }
  .mobile_wrap .children_citactive{
    color: #2FA96B;
    font-weight: bold;
  }
  .mobhome_banner{
    width: 100%;
    height: auto;
    padding-top: 1.777778rem;
  }
  .mobhome_banner_cont{
    width: 100%;
    height: auto;
  }
  .mobhome_banner_cont img{
    display: block;
    width: 100%;
  }
  .mobhome_download{
    width: 100%;
    height: 1px;
    position: relative;
  }
  .mobhome_dcont{
    width: 50%;
    height: 0.888889rem;
    display: flex;
    justify-content: flex-start;
    position: absolute;
    left: calc(50% - 160px);
    top: -1.1rem;
  }
  .mobhome_dcont_items{
    width: 3.083333rem;
    height: 0.888889rem;
    box-sizing: border-box;
    padding-left: 0.555556rem;
  }
  .mobhome_dcont_items img{
    display: block;
    width: 100%;
  }
  .mobhome_onewrap{
    width: 100%;
    height: auto;
    padding-top: 1.083333rem;
  }
  .mobhome_oneview{
    width: 71.53%;
    height: auto;
    margin: 0 auto;
  }
  .mobhome_oneview img{
    display: block;
    width: 100%;
  }
  .mobhome_border{
    width: 88.89%;
    padding-top: 1.916667rem;
    margin: 0 auto;
  }
  .mobhome_twoview{
    width: 88.89%;
    height: 11rem;
    margin: 0 auto;
    position: relative;
  }
  .mobhome_tvbgimg{
    display: block;
    width: 100%;
  }
  .mobhome_tview{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
  }
  .mobhome_thrview{
    width: 100%;
    height: 0.916667rem;
    margin: 11px auto 0 auto;
  }
  .mobhome_thrview img{
    width: 43.47%;
    display: block;
    margin: 0 auto;
  }
  .mobhome_fivborder{
    width: 88.89%;
    padding-top: 1.916667rem;
    margin: 0 auto;
  }
  .mobfooter_wrap{
    width: 100%;
    height: auto;
    background: #0A0B0E;
    padding-top: 1.944444rem;
    padding-bottom: 1.944444rem;
  }
  .mobfooter_cont{
    width: 88.89%;
    height: auto;
    margin: 0 auto;
  }
  .mobfooter_title{
    width: 100%;
    height: 0.444444rem;
    font-size: 0.444444rem;
    font-weight: 600;
    color: #E8E8E9;
    line-height: 0.444444rem;
  }
  .mobfooter_list{
    width: 100%;
    height: auto;
    padding-top: 0.333333rem;
  }
  .mobfooter_items{
    width: 100%;
    height: 1.5rem;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
  }
  .mobfooter_ileft{
    width: auto;
    height: 1.5rem;
    font-size: 0.388889rem;
    font-weight: 400;
    color: #E8E8E9;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .mobfooter_ileft_active{
    color: #39CA80;
  }
  .mobfooter_iright{
    width: 0.277778rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
  }
  .mobfooter_iright img{
    display: block;
    width: 100%;
    height: 0.416667rem;
  }
  .mobfooter_middle{
    width: 100%;
    height: auto;
    padding-top: 1.388889rem;
  }
  .mobfooter_mimg{
    width: 100%;
    padding-top: 0.611111rem;
  }
  .mobfooter_mimg img{
    display: block;
    width: 4.861111rem;
  }
  .mobfooter_down{
    width: 100%;
    padding-top: 1.388889rem;
  }
  .mobfooter_dlist{
    width: 100%;
    height: auto;
    padding-top: 0.333333rem;
  }
  .mobfooter_dlitem{
    width: 100%;
    height: auto;
    padding-top: 0.555556rem;
    font-size: 0.388889rem;
    font-weight: 400;
    color: #B6B8BF;
  }
  .mobhome_tview .eshoy_slider_cont{
      width: 100%;
      background: none;
  }
  .mobhome_tview .sliderbox_wrap{
      width: 87.5%;
      margin: 0 auto;
  }
  .mobhome_tview .sliderbox_left{
      width: 16.3%;
      height: 1.194444rem;
  }
  .mobhome_tview .sliderbox_middle{
      width: 60%;
  }
  .mobhome_tview .sliderbox_right{
      width: 16.3%;
      height: 1.194444rem;
  }
  .mobhome_tview .sliderbox_cimg{
     width: 100%;
     height: 0.694444rem;
  }
  .mobhome_tview .sliderbox_ctext{
    width: 100%;
    height: 0.5rem;
    line-height: 0.5rem;
    font-size: 0.25rem;
  }
  .mobhome_tview .sliderBox{
      width: 100%;
  }
  .mobhome_tview .loan-content-box{
     padding-top: 1.111111rem;
  }
  .mobhome_tview .moneybox{
     font-size: 0.805556rem;
     padding-bottom: 1.111111rem;
  }
  .mobhome_tview .moneybox span {
    font-size: 0.805556rem;
  }
  .mobhome_tview .loan-select-box{
    width: 87.5%;
  }
  .mobhome_tview .loan-select-item {
    width: 30%;
    height: 0.833333rem;
    font-size: 12px;
    line-height: 0.833333rem;
  }
  .mobhome_tview .loan-select-item.selected{
    background: #FFFFFF rgba(165,247,170,0.06);
    box-shadow: 0px 25px 50px 0px rgba(69,69,69,0.06);
    border-radius: 25px;
    box-sizing: border-box;
    border: 1px solid #3CCA8C;
    color: #3CCA8C;
    font-size: 12px;
    font-weight: 600;
  }
  .mobhome_tview .sliderbox_wrap{
    padding-top: 0.583333rem;
  }
  .mobhome_tview .sliderBox{
    margin: 0.35rem auto 0 auto;
  }
  .mobhome_tview .el-slider__bar{
    height: 0.138889rem !important;
    border-radius: 0.069444rem !important;
  }
  .mobhome_tview .el-slider__runway{
    height: 0.138889rem !important;
    border-radius: 0.069444rem !important;
  }
  .mobhome_tview .el-slider__button-wrapper{
      width: 0.972222rem !important;
      height: 0.972222rem !important;
      top: -0.388889rem !important;
  }
  .mobhome_tview .sliderbox_wrap{
      height: 2.2rem;
  }
  .mobhome_tview .eshoy_slider_btns{
      width: 8.888889rem;
      height: 1.0rem;
      margin-top: 0;
  }
  .mobhome_tview .eshoy_slider_btn_view{
      width: 8.888889rem;
      height: 1.0rem;
  }

  /* 1px边框 底部*/
  .scale-1px-home{
    position: relative;
    border:none;
  }
  .scale-1px-home:after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.2);
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }

  /* 1px边框 底部*/
  .scale-1px{
    position: relative;
    border:none;
  }
  .scale-1px:after{
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    background: #DEE0E6;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  /* 1px边框 顶部*/
  .scaletop-1px{
    position: relative;
    border:none;
  }
  .scaletop-1px:after{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    background: #DEE0E6;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  /* 1px边框 右边*/
  .scaleright-1px{
    position: relative;
    border:none;
  }
  .scaleright-1px:after{
    content: '';
    position: absolute;
    right: 0;
    background: #DEE0E6;
    width: 1px;
    height: 100%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  /* 1px边框 左边*/
  .scaleleft-1px{
    position: relative;
    border:none;
  }
  .scaleleft-1px:after{
    content: '';
    position: absolute;
    left: 0;
    background: #DEE0E6;
    width: 1px;
    height: 100%;
    -webkit-transform: scaleX(0.5);
    transform: scaleX(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .laita_solider_down_view{
    width: 616px;
    height: 24px;
    margin: 48px auto 0 auto;
  }
  .laita_solider_down_view img{
    display: block;
    width: 616px;
    height: 24px;
  }
  .mobhome_tview .laita_solider_down_view{
    width: 8.694444rem;
    height: 0.333333rem;
    margin: 0.666667rem auto 0 auto;
  }
  .mobhome_tview .laita_solider_down_view img{
    display: block;
    width: 8.694444rem;
    height: 0.333333rem;
  }
  .laite_descview{
    width: 100%;
    height: auto;
    padding: 136px 0 0 0;
  }
  .laite_descview_list{
    width: 100%;
    height: 523px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
  }
  .laite_descvitems{
    width: 360px;
    height: 792px;
    position: relative;
  }
  .laite_descvitem{
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .mobhome_dview .laite_descview{
    width: 100%;
    height: auto;
    padding: 1.888889rem 0 2.277778rem 0;
  }
  .mobhome_dview .laite_descview_list{
    width: 100%;
    height: auto;
    margin: 0 auto;
  }
  .laite_descvitems{
    width: 360px;
    height: auto;
    position: relative;
    margin: 0 auto 0 auto;
  }
  .Index .el-dialog {
    border-radius: 40px;
    overflow: hidden;
  }
  .laita_about_view{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0px 60px 40px 60px;
  }
  .laita_about_title {
    width: 100%;
    height: 88px;
    font-weight: 500;
    font-size: 40px;
    color: #444444;
    line-height: 47px;
    text-align: center;
    font-style: normal;
  }
  .laita_about_desc {
    width: 100%;
    height: auto;
    font-weight: 400;
    font-size: 28px;
    color: #444444;
    line-height: 48px;
    text-align: left;
    font-style: normal;
  }
  .laita_fraude_icon{
    width: 64px;
    height: 64px;
    margin: 0 auto 18px auto;
  }
  .laita_fraude_title{
    width: 100%;
    height: 24px;
    position: relative;
    margin-top: 20px;
  }
  .laita_fraude_close{
    width: 40px;
    height: 40px;
    position: absolute;
    right: 20px;
    top: 0;
    cursor: pointer;
  }
  #lalanita_fradue .el-dialog__body{
    padding-top: 0;
  }
  .laita_fraude_message{
    width: 86%;
    height: auto;
    font-weight: 400;
    font-size: 28px;
    color: #444444;
    line-height: 46px;
    text-align: center;
    font-style: normal;
    margin: 40px auto 0 auto;
  }
  .laita_fraude_connect{
    width: 100%;
    height: auto;
    margin-top: 16px;
    box-sizing: border-box;
    padding-left: 350px;
  }
  .laita_fraude_cnttext{
    width: 100%;
    font-weight: 400;
    font-size: 28px;
    color: #444444;
    line-height: 46px;
    text-align: left;
    font-style: normal;
  }
  .laita_fraude_warnview{
    width: 100%;
    height: auto;
    font-weight: 400;
    font-size: 24px;
    color: #FF7648;
    line-height: 34px;
    text-align: center;
    font-style: normal;
    margin-top: 40px;
  }
  .beat_prize_wrap{
    width: 100%;
    height: 876px;
    margin: 96px auto 0 auto;
    position: relative;
    background: #ffffff;
  }
  .beat_prize_cont{
    width: 100%;
    height: 548px;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: center;
  }
  .ndan_prizelist_cdv{
    width: 100%;
    height: 548px;
    border-radius: 0.305556rem;
    position: relative;
    overflow: hidden;
  }
  .ndan_prizelist_cdv ul { width: 100%; height: auto; position: relative;background: #ffffff;}
  .ndan_prizelist_cdv ul li {
    width: 410px;
    height: auto;
    float: left;
    list-style: none;
    margin-right: 5px;
    margin-bottom: 180px;
    background: #FFFFFF;
    border-radius: 10px;
  }
  .baroli_hscrollcdview{
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 32px 14px 0 14px;
  }
  .baroli_hscdv_head{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .baroli_hscdv_hleft{
    width: 260px;
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .baroli_hscdv_hlavator{
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .baroli_hscdv_hlavator img{
    display: block;
    width: 40px;
    height: 40px;
  }
  .baroli_hscdv_hlmobile{
    width: auto;
    height: 20px;
    font-weight: 400;
    font-size: 14px;
    color: #808187;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding-left: 12px;
  }
  .baroli_hscdv_hright{
    width: 108px;
    height: 20px;
  }
  .baroli_hscdv_hright img{
    display: block;
    width: 108px;
    height: 20px;
  }
  .baroli_hscdv_down{
    width: 100%;
    padding-top: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .baroli_hscrmask_left{
    width: 300px;
    height: 402px;
    background: linear-gradient( 270deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
    position: absolute;
    left: 0;
    top: 0;
  }
  .baroli_hscrmask_right{
    width: 300px;
    height: 402px;
    background: linear-gradient( 270deg,  #FFFFFF 0%, rgba(255,255,255,0)100%);
    position: absolute;
    right: 0;
    top: 0;
  }
  .lalascroll_downview{
    width: 100%;
    height: auto;
    margin: 102px 0 64px 0;
  }
  .lalascroll_downtext{
    width: 100%;
    height: auto;
    font-weight: 400;
    font-size: 24px;
    color: #D2D2D2;
    line-height: 30px;
    text-align: center;
    font-style: normal;
  }
  .lalanitahome1v{
    width: 1236px;
    height: 744px;
    margin: 116px auto 0 auto;
  }
  .lalanitahome1v_view{
    width: 100%;
    height: 248px;
    display: none;
  }
  .lalanitahome1v .lalanitahome1v_view_active{
    display: block;
  }
  .lalanitahome1v_vtop{
    width: 100%;
    height: 247px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .lalanitahome1v_vtleft{
    width: 516px;
    height: 247px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .lalanitahome1v_vtlmg{
    width: 120px;
    height: 120px;
  }
  .lalanitahome1v_vtltx{
    width: 282px;
    height: 108px;
    box-sizing: border-box;
    padding: 0 0 0 32px;
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 28px;
    color: #383A39;
    line-height: 36px;
    text-align: left;
    font-style: normal;
  }
  .lalanitahome1v_vtright{
    width: 720px;
    height: 247px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .lalanitahome1v_vtright span{
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 28px;
    color: #5F6B65;
    line-height: 34px;
    text-align: left;
    font-style: normal;
  }
  .lalanitahome1v_vdon{
    width: 1200px;
    height: 1px;
    margin: 0 auto;
  }
  .lalanitahome2v{
    width: 1239px;
    height: auto;
    margin: 156px auto 0 auto;
  }
  .lalanitahome2v_head{
    width: 100%;
    height: 200px;
  }
  .lalanitahome2v_ht{
    width: 100%;
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 46px;
    color: #383A39;
    line-height: 52px;
    text-align: center;
    font-style: normal;
  }
  .lalanitahome2v_hmg{
    width: 360px;
    height: 260px;
  }
  .lalanitahome2v_hmg img{
    display: block;
    width: 360px;
    height: 260px;
  }
  .lalanitahome2v_d12{
    width: 100%;
    height: 176px;
    box-sizing: border-box;
    padding: 36px 0 24px 0;
  }
  .lalanitahome2v_d1{
    width: 100%;
    height: 56px;
    font-family: MiSans, MiSans;
    font-weight: bolder;
    font-size: 28px;
    color: #383A39;
    line-height: 32px;
    text-align: left;
    font-style: normal;
  }
  .lalanitahome2v_d2{
    width: 100%;
    height: 60px;
    font-family: MiSans, MiSans;
    font-size: 28px;
    color: #383A39;
    line-height: 32px;
    text-align: left;
    font-style: normal;
  }
  .lalanitahome2v_d3{
    width: 100%;
    font-family: MiSans, MiSans;
    font-weight: 400;
    font-size: 22px;
    color: #5F6B65;
    line-height: 32px;
    text-align: left;
    font-style: normal;
  }
  .lalanitahome3v{
    width: 100%;
    height: auto;
    padding: 220px 0 0 0;
  }
  .lalanitahome3v_t{
    width: 100%;
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 46px;
    color: #383A39;
    line-height: 52px;
    text-align: center;
    font-style: normal;
  }
  .lalanitahome4v{
    width: 100%;
    height: 740px;
    position:relative;
    overflow:hidden;
  }
  .lalanitahome4v_vmg{
    width: 1920px;
    position:absolute;
    left:50%;
    margin-left:-960px;
  }
</style>
